import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    defaultMessage: "Transaction {actionType}",
    id: "3zdm8A",
    description: "Dialog title",
  },
  warningText: {
    defaultMessage: "Are you sure you want to {actionType} this transaction?",
    id: "VyKl39",
    description: "Dialog warning text",
  },
});
